import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useUserContext } from './UserContext';
import { getFreshAccessToken } from './UserContext';

const baseUrl = process.env.REACT_APP_API_URL;
const endpointEventsDetail = `${baseUrl}/elements-details`; // Endpoint pour récupérer les détails des événements

const EventDetailContext = createContext();

export const EventDetailProvider = ({ children }) => {
  const { tokens } = useUserContext();
  const [details, setDetails] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);



const fetchEventDetails = async (eventId) => {
  if (!eventId) {
    console.error('[EventDetailContext] ❌ eventId manquant');
    setDetails([]);
    setErrorDetails('eventId manquant');
    return;
  }

  setLoadingDetails(true);

  try {
    const token = await getFreshAccessToken(); // 👈 utilise toujours le token rafraîchi
    if (!token) throw new Error('Token manquant ou invalide');

    const url = `${endpointEventsDetail}?eventId=${eventId}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = response.data;
    console.log('[fetchEventDetails] ✅ Réponse reçue :', data);

    if (Array.isArray(data)) {
      setDetails(data);
      setErrorDetails(null);
    } else {
      console.error('[fetchEventDetails] ⚠️ Données inattendues :', data);
      setDetails([]);
      setErrorDetails('Réponse inattendue du serveur');
    }

  } catch (err) {
    console.error('[fetchEventDetails] ❌ Erreur :', err.response?.status, err.message);
    setDetails([]);
    setErrorDetails(err.message || 'Erreur inconnue');
  } finally {
    setLoadingDetails(false);
  }
};


  return (
    <EventDetailContext.Provider value={{ details, loadingDetails, errorDetails, fetchEventDetails }}>
      {children}
    </EventDetailContext.Provider>
  );
};

export const useEventDetailContext = () => useContext(EventDetailContext);
